@if (consent.showBanner()) {
  <div class="cookie-banner" role="region" aria-label="Cookie-Einstellungen">
    <div class="cookie-banner__card">
      <div class="cookie-banner__inner">
        <div class="cookie-banner__copy">
          <p class="cookie-banner__title">Cookie-Hinweis</p>
          <p class="cookie-banner__text">
            Wir verwenden Cookies und ähnliche Technologien für Statistik und optional ein Feedback-Widget. Details in
            der
            <a routerLink="/datenschutz" class="cookie-banner__link">Datenschutzerklärung</a>.
          </p>
        </div>
        <div class="cookie-banner__actions">
          <ion-button class="cookie-btn cookie-btn--ghost" fill="outline" shape="round" size="default" (click)="onNecessary()">
            Nur notwendige
          </ion-button>
          <ion-button class="cookie-btn cookie-btn--ghost" fill="outline" shape="round" size="default" (click)="consent.openCookieSettings()">
            Einstellungen
          </ion-button>
          <ion-button class="cookie-btn cookie-btn--primary" shape="round" size="default" (click)="onAcceptAll()">
            Alle akzeptieren
          </ion-button>
        </div>
      </div>
    </div>
  </div>
}

<ion-modal
  [isOpen]="consent.settingsModalOpen()"
  (didDismiss)="onModalDismiss()"
  (ionModalDidPresent)="onModalDidPresent()"
  class="cookie-settings-modal"
>
  <ng-template>
    <ion-header class="cookie-settings__header">
      <ion-toolbar class="cookie-settings__toolbar">
        <ion-title class="cookie-settings__title ion-text-start">Cookie-Einstellungen</ion-title>
        <ion-buttons slot="end">
          <ion-button
            class="cookie-btn cookie-btn--toolbar cookie-settings__close--text"
            fill="clear"
            shape="round"
            (click)="consent.closeCookieSettings()"
          >
            Schliessen
          </ion-button>
          <ion-button
            class="cookie-btn cookie-btn--close-icon cookie-settings__close--icon"
            fill="clear"
            shape="round"
            (click)="consent.closeCookieSettings()"
            aria-label="Schliessen"
          >
            <img
              src="assets/icons/close.svg"
              alt=""
              class="cookie-settings__close-img"
              width="22"
              height="22"
              aria-hidden="true"
            />
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding cookie-settings__body">
      <p class="cookie-settings__intro">
        Wähle, welche optionalen Dienste wir laden dürfen. Notwendige Cookies für Betrieb und Sicherheit sind
        immer aktiv.
      </p>
      <ion-item lines="none" class="cookie-settings__item">
        <ion-toggle
          justify="space-between"
          [checked]="draftAnalytics()"
          (ionChange)="draftAnalytics.set($event.detail.checked)"
        >
          Statistik (Google Analytics, Microsoft Clarity)
        </ion-toggle>
      </ion-item>
      <ion-item lines="none" class="cookie-settings__item">
        <ion-toggle
          justify="space-between"
          [checked]="draftFeedback()"
          (ionChange)="draftFeedback.set($event.detail.checked)"
        >
          Feedback-Widget (Usersnap)
        </ion-toggle>
      </ion-item>
    </ion-content>
    <ion-footer class="cookie-settings__footer-bar">
      <ion-toolbar class="cookie-settings__footer-toolbar">
        <div class="cookie-settings__footer-slot">
          <ion-button class="cookie-btn cookie-btn--primary" expand="block" shape="round" size="default" (click)="onSaveCustom()">
            Speichern
          </ion-button>
        </div>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>
